import fastdom from 'fastdom';
import { makeDebugger } from '@lib';

const debug = makeDebugger('ModalRegistry');

type ModalRegistryItemOptions = {
  dimmed: boolean;
};

class ModalRegistry {
  registry = new Map();

  add = (id: string, options: ModalRegistryItemOptions): boolean => {
    debug(`add(id: "${id}")`);
    this.registry.set(id, options);
    this.setup();
    return true;
  };

  remove = (id: string): boolean => {
    const result = this.registry.delete(id);
    debug(`remove(id: "${id}"): ${result}`);
    if (result) {
      this.applyDimmerClasses();
    }
    return result;
  };

  private setup = () => {
    this.applyDimmerClasses();
  };

  // private cleanup = () => {};

  private applyDimmerClasses = () => {
    // We want to apply classes to the body that will prevent scrolling.
    // Will fix the issue of background scrolling
    const dim = Array.from<ModalRegistryItemOptions>(this.registry.values()).some(opt => opt.dimmed);
    fastdom.mutate(() => {
      document.body.classList.toggle('dimmed', dim);
      document.body.classList.toggle('dimmable', dim);
    });
  };
}

export const modalRegistry = new ModalRegistry();
